import { useState, useEffect } from "react";
import { IComment, IGroundEvent, IFullFlight } from "@vmosolutions/oc-interfaces";
import { Grid, Typography, styled } from "@mui/material";
import { EventCommentForm } from "./EventCommentForm";
import { EventComment } from "./EventComment";

export interface IDisplayEventCommentsProps {
  windowId: string;
  isFlight: boolean;
  eventId: string;
  comments: IComment[];
  updateEvent?: (event: IGroundEvent) => void;
  setLoadedFlight?: (flightValues: IFullFlight) => void;
  setLoadedGroundEvent?: (eventValues: IGroundEvent) => void;
  updateTabState?: (dirtyStatus: boolean) => void; // update parent with dirty status.
}

const OCDisplayEventComments = styled(Grid)(({ theme }) => ({
  "& .add_comment_card": {
    padding: "3px",
    marginLeft: "5px",
    marginRight: "5px",
    "&:after": {
      transform: "scale(0,0)",
      transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter,
      }),
    },
    "& .click_to_add": {
      justifyContent: "center",
      "& .MuiButton-text": {
        fontSize: "inherit",
      },
    },
  },

  "& .comment_form": {
    maxWidth: "800px !important",
    "& .submit_textarea .input_control": {
      "& div": {
        "&.input-base": {
          "&.MuiInputBase-multiline": { width: "100%" },
        },
      },
    },
    "& .buttons": {
      display: "flex",
      justifyContent: "space-between",
      "& .clear_comment, & .submit_comment": {
        display: "flex",
        padding: "2px 8px",
      },
    },
  },

  "& .flight_comments": {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    "& .no_comments": {
      margin: 10,
    },
  },
}));

/**
 * A wraper commponet to display the componet to add a comment to a flight  &
 * display all the comments currently on a flight
 * @param props - flight: IFullEvent
 */

export const DisplayEventComments = (props: IDisplayEventCommentsProps): JSX.Element => {
  const { windowId, isFlight, eventId, comments, updateEvent, setLoadedFlight, setLoadedGroundEvent, updateTabState } =
    props;

  const [displayComments, setDisplayComments] = useState<IComment[]>([]);
  // Creates a shallow copy of the original comments array with a reverse order.
  useEffect(() => setDisplayComments(comments?.length > 0 ? comments.slice(0)?.reverse() : []), [comments]);

  return (
    <OCDisplayEventComments container direction={"column"}>
      <EventCommentForm
        windowId={windowId}
        isFlight={isFlight}
        eventId={eventId}
        setLoadedFlight={setLoadedFlight}
        setLoadedGroundEvent={setLoadedGroundEvent}
        updateTabState={updateTabState}
      />
      <Grid item className="flight_comments">
        {displayComments?.length ? (
          displayComments.map((comment: IComment, index: number) => (
            <Grid key={index} item className="message" style={{ display: "flex", height: "auto", margin: "5px 8px" }}>
              <EventComment
                index={index}
                timeStamp={comment?.createdAt?.valueOf() ?? null}
                user={comment?.username ?? ""}
                content={comment?.comment ?? ""}
              />
            </Grid>
          ))
        ) : (
          <Typography variant="body2" className="no_comments">
            {`To add a comment to this ${isFlight ? "flight" : "ground event"}, please use the text area input above.`}
          </Typography>
        )}
      </Grid>
    </OCDisplayEventComments>
  );
};
